import { styler, timeline } from 'popmotion';
import { tweenLeft, setLabels } from "./animations";
/* eslint no-console: "off", no-unused-vars: "off" */

export default function animateProductCards() {
	const container = document.querySelector('.main-benefits__content');

	if (!container) return;

	const productCards = [...container.children].map(styler);

	const productCardsLabels = setLabels(productCards, 'product');

	const setStylers = (v) => {
		productCardsLabels.forEach((label, i) => {
			if (v[label] !== undefined) productCards[i].set(v[label])
		});
	};

	const showProductCards = () => {
		timeline([
			[...productCards.map((product, i) => tweenLeft(productCardsLabels[i], 1000, 50)), 50]
		]).start(setStylers);
	};

	showProductCards();
}
